import { HtmlTitle } from '@app/components/html';
import { useToken } from '@app/core/auth/authentication/hooks/useToken';
import { useQueryParam } from '@mi-front/core';
import { Box } from '@mui/material';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { LoginIntro } from './components/LoginIntro';
import { LoginPanel } from './components/LoginPanel';

export function LoginPage() {
  const { $t } = useIntl();
  const redirectTo = useQueryParam('redirect_to');
  const token = useToken();
  const history = useHistory();

  // Redirect only when TokenGate resolved a real access token (not stale isAuthenticated)
  useEffect(() => {
    if (token) {
      history.push(redirectTo || '/');
    }
  }, [token, redirectTo, history]);

  if (token) {
    return null;
  }

  return (
    <Box display="flex" className="vh-100">
      <HtmlTitle
        text={$t({
          id: 'auth.loginScreen.title',
          defaultMessage: 'Login',
        })}
      />
      <LoginPanel />
      <LoginIntro />
    </Box>
  );
}
